/*
  * Usage:

  const timeline1 = timelineFactory()
  const timeline2 = timelineFactory()

  async onEvent(){
    const waitFor = timeline1()

    * If onEvent is called again anything using the old waitFor promise will never resolve. 
    * (Though it can still be garbage collected)
    const data = await waitFor(
      fetch('google.com')
    )

    console.log(data)
  }

  onEvent() ! cancelled
  onEvent() ! cancelled
  onEvent() * logs data

  (note three requests will still be made. But nothing after the request will run)
  
  If you wanted to skip the request you could add 
  `await waitFor(10)` immediately after `const waitFor = timeline1()`
  
*/

function timelineFactory () {
  let cancel = false

  return function timeline () {
    if (typeof cancel === 'function') cancel()
    let cancelled = false

    cancel = () => {
      cancelled = true
    }

    function waitFor (timeOrPromise) {
      return new Promise(resolve => {
        if (timeOrPromise instanceof Promise) {
          timeOrPromise.then((arg) => {
            if (!cancelled) {
              resolve(arg)
            }
          })
        } else {
          setTimeout(() => {
            if (!cancelled) {
              resolve()
            }
          }, timeOrPromise)
        }
      })
    }

    waitFor.cancelled = () => cancelled

    return waitFor
  }
}

export default timelineFactory
